<template>
	<div>
		<div
			v-if="typeof tableData.bind == 'string' && !Array.isArray(scope.row[tableData.bind])"
			:style="[tableData.style, getStyle()]"
			@click="webskip"
			class="percentage"
		>
			{{ content() }}
		</div>

		<div v-if="Array.isArray(tableData.bind)">
			<div v-for="item in tableData.bind" :key="item.bind">
				<span :style="getStyle(item)">{{ getValue(item) }}</span>
			</div>
		</div>

		<div v-if="Array.isArray(scope.row[tableData.bind])">
			<div v-for="(item, index) in scope.row[tableData.bind]" :key="index">
				<span>{{ getArrayValue(item) }}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		tableData: Object,
		scope: Object,
	},
	data() {
		return {};
	},
	mounted() {},
	methods: {
		webskip() {
			let { scope, tableData } = this;
			tableData.webskip && tableData.webskip(scope.row[tableData.bind], scope.row);
		},
		content() {
			let val = this.scope.row[this.tableData.bind];
			return (
				(this.tableData.dataStyle && this.tableData.dataStyle(val, this.scope.row)) ||
				this.scope.row[this.tableData.bind]
			);
		},
		getValue(item) {
			if (item && item.custValue) return item.custValue(this.scope.row);
			return this.scope.row[item.bind];
		},
		getArrayValue(val) {
			let { scope, tableData } = this;
			return tableData.dataStyle(val, scope.row);
		},
		getStyle(item) {
			if (item && item.custStyle) return item.custStyle(this.scope.row);
			if (this.tableData.getStyle)
				return this.tableData.getStyle(this.scope.row[this.tableData.bind], this.scope.row);
			return undefined;
		},
	},
	computed: {},
	components: {},
};
</script>

<style lang="scss" scoped></style>
